import axios from 'axios'
import Cookies from './Cookies'

// const ROLE = ['ADMIN', 'AGENT', 'PARTNER', 'USER']

class User {

    constructor() {
        this.id = null
        this.username = ''
        this.password = ''
        this.email = ''
        this.phone = ''
        this.picture = ''
        this.sexe = ''
    }
}

export class succursale {
    constructor() {
        this.name = ''
        this.country = ''
        this.state = ''
        this.city = ''
        this.postalCode =''
        this.address = ''
    }
}

class PartnerUser extends User {

    constructor() {
        super()
        this.brancheActivity = ''
        this.descriptionCompagny=''
        this.categoryActivity = ''
        this.city = ''
        this.country = ''
        this.emailCompany = ''
        this.email = ''
        this.firstName = ''
        this.lastName = ''
        this.nameCompagny = ''
        this.nbSuccursales = 0
        this.phoneCompany = ''
        this.phone = ''
        this.poste = ''
        this.postalCode = ''
        this.rueNumber = ''
        this.password = ''
        this.confirmPassword = ''
        this.webSite = ''
        this.gender = ''
        this.state = ''
        this.succursale = []
        this.code = '' // au min 4 caractère
        this.inWebSite = false
        this.promotionTitle = ''
        this.promotionWebSite = ''
        this.pomotionPercenter = 0
        this.promotionOffer = ''
        this.promotionDescription = ''
        this.promoStart = new Date().toISOString().substr(0, 10)
        this.promoEnd = new Date().toISOString().substr(0, 10)
    }
}

export class PartnerUserRegister extends PartnerUser {
    constructor() {
        super()
        this.confirmPassword = ''
        this.activityBranch = ''
        this.category = ''
    }
}

export class PartnerUserAuth extends PartnerUser {

    constructor() {
        super()
        this.token = ''
    }
}

export class Security {

    constructor(partnerUser, router, store) {
        this._user = partnerUser
        this._router = router
        this._store = store
    }

    set user(value) {
        this._user = value
    }

    isAuth() {
        if (this._user instanceof PartnerUserAuth) return this._user.id !== null && this._user.token !== ''
        return null
    }

    async login(path) {
        const {email, password} = this._user
        let result
        await axios.post('/api/login', {
            username: email,
            password: password
        }).then((response) => {
            result = response
            const tmp = this._user
            this._user = new User()
            this._user.id = tmp.id
            this._user.email = tmp.email
            this._user.phone = tmp.phone
            this._user.password = tmp.password
            const cookie = new Cookies('user_key_auth', JSON.stringify(this._user), 1)
            this._store.commit('user/setUser', this._user)
            this._router.push({name: path.name})
        }).catch((error) => {
            result = error.response.data
        })
        return result
    }

    logout(path) {
        let islogout = false
        Cookies.eraseCookie('user_key_auth')
        this._store.commit('setUser', new User())
        this._router.push({name: path.name}).then(() => {
            islogout = true
        })
        return islogout
    }
}

export default User
